
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tracks/[trackId]",
      function () {
        return require("private-next-pages/tracks/[trackId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tracks/[trackId]"])
      });
    }
  